import React from "react";
import { TiArrowSortedUp } from "react-icons/ti";
import { TiArrowSortedDown } from "react-icons/ti";

import { useSelector, useDispatch } from "react-redux";

import { sortVatFields } from "../../store/slice/mappingSlice";

const MappingWindowHeader = ({ onSortPdFields }) => {
  const dispatch = useDispatch();
  const isVatSort = useSelector((state) => state.mapping.isVatSort);
  const isPdSort = useSelector((state) => state.mapping.isPdSort);

  const onSortVatFields = () => {
    dispatch(sortVatFields());
  };

  return (
    <tr>
      <th
        className={
          "mapping-header-label " +
          (isVatSort !== undefined && "selected-header ")
        }
        onClick={onSortVatFields}
        style={{ width: "500px" }}
      >
        <div className="my-auto ms-3">
          Company
          <span className="ms-1">
            {isVatSort === true && <TiArrowSortedUp className="sort-icon" />}
            {isVatSort === false && <TiArrowSortedDown className="sort-icon" />}
          </span>
        </div>
      </th>
      <th
        className={
          "mapping-header-label " +
          (isPdSort !== undefined && "selected-header ")
        }
        onClick={onSortPdFields}
      >
        <div className="my-auto ms-2">
          Pipedrive
          <span className="ms-1">
            {isPdSort === true && <TiArrowSortedUp className="sort-icon" />}
            {isPdSort === false && <TiArrowSortedDown className="sort-icon" />}
          </span>
        </div>
      </th>
      <th className="text-center mapping-header-label actions-container">
        <div className="pe-2">Actions</div>
      </th>
    </tr>
  );
};

export default MappingWindowHeader;
